import React from 'react';

import { Field } from 'redux-form';

import type { JobFieldProps } from './job-field';

import { JobNotificationSettings } from '../settings/job-notification-settings';

import { JobField } from './job-field';

interface Props extends JobFieldProps {
  jobId: number;
  isSubmitting: boolean;
  showOnlyRequiredNotificationTypes?: boolean;
}

export const JobFieldNotificationSettings = (props: Props) => (
  <JobField
    {...props}
    title="Email Notifications"
    caption="Set up who receives notifications, and what kind of notifications they receive"
    editView={
      <Field
        name="notificationSettings"
        component={JobNotificationSettings}
        jobId={props.jobId}
        isEditing={props.isEditing}
        isSubmitting={props.isSubmitting}
        showOnlyRequiredNotificationTypes={props.showOnlyRequiredNotificationTypes}
      />
    }
  />
);
